export default "__VITE_ASSET__CHhUri9H__"